import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BookingRepository } from '@app/store/booking.repository';
import {
  IonButton,
  IonIcon,
  IonText,
  ModalController,
} from '@ionic/angular/standalone';
import { TranslocoPipe } from '@jsverse/transloco';
import { addIcons } from 'ionicons';
import { closeOutline } from 'ionicons/icons';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-welcome-onboarding-modal',
  standalone: true,
  imports: [
    CommonModule,
    TranslocoPipe,
    IonButton,
    IonIcon,
    IonText,
  ],
  templateUrl: './welcome-onboarding.modal.html',
  styleUrls: ['./welcome-onboarding.modal.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WelcomeOnboardingModalComponent {
  /** Optional override; defaults to the active booking property name. */
  @Input() propertyName?: string;

  public readonly propertyName$ = this.bookingRepository.activeBooking$.pipe(
    map((booking) => this.propertyName ?? booking?.property?.name ?? ''),
  );

  constructor(
    private readonly modalCtrl: ModalController,
    private readonly bookingRepository: BookingRepository,
  ) {
    addIcons({ closeOutline });
  }

  dismiss(): Promise<boolean> {
    return this.modalCtrl.dismiss();
  }
}
